import React, { useEffect, useState } from "react";
import { FaWallet } from "react-icons/fa";
import { FaFilter } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import {  FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaHistory } from "react-icons/fa";
import axios from "axios";
import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Cash = ({ clientData }) => {
    const navigate = useNavigate();
  const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [filteredCashData, setFilteredCashData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
const [historyData, setHistoryData] = useState([]);
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
const [editId, setEditId] = useState(null);
  // const client_id = localStorage.getItem("client_id");
const client_id = clientData?.client_id || clientData?.id || null;
const [cashData, setCashData] = useState([]);
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
const [formData, setFormData] = useState({
  client_id,
  adj_type: "",
  amount: "",
  adj_on: "",
  description: "",
  c_type: "",
  invoiceNo: "",
});
// useEffect(() => {
//   fetchCashData();
// }, []);
useEffect(() => {
  if (!client_id) {
    console.log("Client ID not available yet");
    return;
  }

  fetchCashData();
}, [client_id]);
const handleEdit = (item) => {
  setIsEdit(true);
  setEditId(item.id);

  setFormData({
    ...item,
    adj_on: item.adj_on.split(" ")[0],
    last_data: item,
  });

  setShowPartyForm(true);
};
const handleEditSale = async (invoiceNo) => {
  try {
    if (!invoiceNo) {
      showError("Invoice number not found");
      return;
    }

    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-inv-no/${invoiceNo}`
    );

    const saleData = res.data?.[0];

    if (!saleData) {
      showError("Sale bill not found");
      return;
    }

    navigate("/add-sale", {
      state: saleData,
    });
  } catch (error) {
    console.error(
      "Edit Sale Error:",
      error.response?.data || error.message
    );

    showError("Failed to open sale bill");
  }
};
const getNextInvoiceNo = () => {
  if (!cashData || cashData.length === 0) {
    return 1;
  }

  const invoiceNumbers = cashData
    .map((item) => Number(item.invoiceNo))
    .filter((num) => Number.isFinite(num) && num > 0);

  if (invoiceNumbers.length === 0) {
    return 1;
  }

  return Math.max(...invoiceNumbers) + 1;
};
const handleFilter = () => {
  if (!fromDate || !toDate) {
    setFilteredCashData(cashData);
    return;
  }

  const filtered = cashData.filter((item) => {
    const date = item.adj_on.split(" ")[0];
    return date >= fromDate && date <= toDate;
  });

  setFilteredCashData(filtered);
};
const handleDelete = (id) => {
  setDeleteId(id);
  setShowDeleteModal(true);
};
// const handleDelete = async (id) => {
//   const confirmDelete = window.confirm(
//     "Are you sure you want to delete this record?"
//   );

//   if (!confirmDelete) return;

//   try {
//     await axios.delete(`https://api.dectwinbilling.com/delete-cash-entry/${id}`);

//     showSuccess("Record deleted successfully.");

//     fetchCashData();
//   } catch (error) {
//     console.log(error);
//     showError("Failed to delete record.");
//   }
// };
const confirmDelete = async () => {
  try {
    await axios.delete(
      `https://api.dectwinbilling.com/delete-cash-entry/${deleteId}`
    );

    showSuccess("Record deleted successfully.");

    setShowDeleteModal(false);
    setDeleteId(null);

    fetchCashData();
  } catch (error) {
    console.log(error);
    showError("Failed to delete record.");
  }
};
const handleView = (item) => {
  console.log("View:", item);
};


// const handleHistory = (item) => {
//   console.log("History:", item);
// };
const handleHistory = (item) => {
  try {
    const history = item.edit_history
      ? JSON.parse(item.edit_history)
      : [];

    setHistoryData(history);
    setShowHistoryModal(true);
  } catch (err) {
    console.log(err);
    setHistoryData([]);
    setShowHistoryModal(true);
  }
};

const fetchCashData = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-cash-entry/${client_id}`
    );

        setCashData(res.data);
    setFilteredCashData(res.data);
   
  } catch (error) {
    console.log(error);
    showError("Failed to fetch cash entries.");
  }
};
// const handleChange = (e) => {
//   const { name, value } = e.target;

//   setFormData((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
// };
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "adj_on") {
    const now = new Date();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const dateTime = `${value} ${hours}:${minutes}:${seconds}`;

    setFormData((prev) => ({
      ...prev,
      adj_on: dateTime,
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};
// const handleSubmit = async () => {
//   try {
//     const res = await axios.post(
//       "https://api.dectwinbilling.com/cash-entry",
//       formData
//     );

//     showSuccess(res.data.message);

//     setShowPartyForm(false);

//     setFormData({
//       client_id,
//     });


//   } catch (err) {
//     console.log(err);
//     showError("Something went wrong.");
//   }
// };      adj_type: "",
//       amount: "",
//       adj_on: "",
//       description: "",
//       c_type: "",
//       invoiceNo: 0,
// 
// const handleSubmit = async () => {
//   try {
//     let res;

//     if (isEdit) {
//       res = await axios.post(
//         `https://api.dectwinbilling.com/update-cash-entry/${editId}`,
//         formData
//       );
//     } else {
//       res = await axios.post(
//         "https://api.dectwinbilling.com/cash-entry",
//         formData
//       );
//     }

//     showSuccess(res.data.message);

//     fetchCashData();

//     setShowPartyForm(false);
//     setIsEdit(false);
//     setEditId(null);

//     setFormData({
//       client_id,
//       adj_type: "",
//       amount: "",
//       adj_on: "",
//       description: "",
//       c_type: "",
//       invoiceNo: 0,
//     });

//   } catch (err) {
//     console.log(err);
//     showError("Something went wrong.");
//   }
// };
const handleSubmit = async () => {
  try {
    let res;

    if (isEdit) {
      // EDIT ke time existing invoiceNo same rahega
      res = await axios.post(
        `https://api.dectwinbilling.com/update-cash-entry/${editId}`,
        {
          ...formData,
          client_id,
          invoiceNo: formData.invoiceNo,
        }
      );
    } else {
      // NEW ENTRY ke liye next invoice number
      const nextInvoiceNo = getNextInvoiceNo();

      const newFormData = {
        ...formData,
        client_id,
        invoiceNo: nextInvoiceNo,
      };

      console.log("Creating Cash Entry:", newFormData);

      res = await axios.post(
        "https://api.dectwinbilling.com/cash-entry",
        newFormData
      );
    }

    showSuccess(res.data.message);

    await fetchCashData();

    setShowPartyForm(false);
    setIsEdit(false);
    setEditId(null);

    setFormData({
      client_id,
      adj_type: "",
      amount: "",
      adj_on: "",
      description: "",
      c_type: "",
      invoiceNo: "",
    });

  } catch (err) {
    console.log("Cash Submit Error:", err);
    showError(
      err.response?.data?.message || "Something went wrong."
    );
  }
};


const getCashSign = (item) => {
  const type = String(item?.adj_type || "")
    .trim()
    .toLowerCase();

  if (type === "add" || type === "withdraw") {
    return 1;
  }

  if (type === "reduce" || type === "deposit") {
    return -1;
  }

  return 0;
};

const getCashAmount = (item) => {
  return Number(item?.amount || 0);
};

const getSignedCashAmount = (item) => {
  return getCashSign(item) * getCashAmount(item);
};

const getTotal = (type) => {
  const now = new Date();

  return cashData
    .filter((item) => {
      const d = new Date(item?.adj_on);

      if (Number.isNaN(d.getTime())) {
        return false;
      }

      // TODAY
      if (type === "today") {
        return d.toDateString() === now.toDateString();
      }

      // THIS MONTH
      if (type === "month") {
        return (
          d.getMonth() === now.getMonth() &&
          d.getFullYear() === now.getFullYear()
        );
      }

      // THIS WEEK
      // Flutter me Monday first day hai
      if (type === "week") {
        const day = now.getDay(); // Sunday = 0

        const mondayOffset =
          day === 0 ? 6 : day - 1;

        const weekStart = new Date(now);

        weekStart.setDate(
          now.getDate() - mondayOffset
        );

        weekStart.setHours(0, 0, 0, 0);

        const weekEnd = new Date(weekStart);

        weekEnd.setDate(
          weekStart.getDate() + 7
        );

        return (
          d >= weekStart &&
          d < weekEnd
        );
      }

      // TOTAL
      return true;
    })
    .reduce((sum, item) => {
      return (
        sum +
        getSignedCashAmount(item)
      );
    }, 0);
};
// const getTotal = (type) => {
//   const today = new Date();

//   return cashData
//     .filter((item) => {
//       const d = new Date(item.adj_on);

//       if (type === "today") {
//         return d.toDateString() === today.toDateString();
//       }

//       if (type === "month") {
//         return (
//           d.getMonth() === today.getMonth() &&
//           d.getFullYear() === today.getFullYear()
//         );
//       }

//       if (type === "week") {
//         const start = new Date(today);
//         start.setDate(today.getDate() - today.getDay());
//         return d >= start && d <= today;
//       }

//       return true; 
//     })
//     .reduce((sum, item) => {
//       return item.adj_type === "Add"
//         ? sum + Number(item.amount)
//         : sum - Number(item.amount);
//     }, 0);
    
// };
const summaryData = [
  {
    title: "Today",
    amount: `₹ ${getTotal("today").toFixed(2)}`,
  },
  {
    title: "This Week",
    amount: `₹ ${getTotal("week").toFixed(2)}`,
  },
  {
    title: "This Month",
    amount: `₹ ${getTotal("month").toFixed(2)}`,
  },
  {
    title: "Total Collection",
    amount: `₹ ${getTotal("total").toFixed(2)}`,
  },
];

  return (
    <>

{showHistoryModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.55)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      padding: "15px",
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "950px",
        background: "#fff",
        borderRadius: "15px",
        padding: "20px",
        maxHeight: "90vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4
          className="mb-0"
          style={{
            color: "var(--primary-color)",
            fontWeight: "700",
          }}
        >
          Edit History
        </h4>

        <button
          className="btn-close"
          onClick={() => setShowHistoryModal(false)}
        ></button>
      </div>

      
      <div
        className="table-responsive"
        style={{
          flex: 1,
          overflow: "auto",
        }}
      >
        <table
          className="table table-bordered table-hover align-middle"
          style={{
            minWidth: "750px",
            marginBottom: 0,
          }}
        >
          <thead
            style={{
              background: "var(--primary-color)",
              color: "#fff",
              position: "sticky",
              top: 0,
              zIndex: 2,
            }}
          >
            <tr>
              <th>Edited On</th>
              <th>Adjustment Date</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Description</th>
            </tr>
          </thead>

          <tbody>
            {historyData.length > 0 ? (
              historyData.map((item, index) => (
                <tr key={index}>
                  <td>
                    {new Date(item.edited_on).toLocaleString("en-IN")}
                  </td>

                  <td>
                    {new Date(item.adj_on).toLocaleString("en-IN")}
                  </td>

                  <td>
                    <span
                      className={`badge ${
                        item.adj_type === "Add"
                          ? "bg-success"
                          : "bg-danger"
                      }`}
                    >
                      {item.adj_type}
                    </span>
                  </td>

                  <td
                    style={{
                      color:
                        item.adj_type === "Add"
                          ? "green"
                          : "red",
                      fontWeight: 600,
                    }}
                  >
                    ₹ {Number(item.amount).toLocaleString()}
                  </td>

                  <td>{item.description || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="text-center py-5 text-muted"
                >
                  No History Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn text-white"
          style={{
            background: "var(--primary-color)",
            minWidth: "120px",
          }}
          onClick={() => setShowHistoryModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
    {showDeleteModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        width: "100%",
        maxWidth: "420px",
        background: "#fff",
        borderRadius: "15px",
        padding: "25px",
      }}
    >
      <h4 className="text-center mb-3">
        Delete Cash Entry
      </h4>

      <p className="text-center text-muted">
        Are you sure you want to delete this record?
      </p>

      <div className="d-flex justify-content-center gap-3 mt-4">
        <button
          className="btn btn-secondary"
          onClick={() => {
            setShowDeleteModal(false);
            setDeleteId(null);
          }}
        >
          Cancel
        </button>

        <button
          className="btn btn-danger"
          onClick={confirmDelete}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}
    
      {showPartyForm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: "15px",
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "700px",
              borderRadius: "20px",
              padding: "25px",
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <button
              onClick={() => setShowPartyForm(false)}
              style={{
                position: "absolute",
                top: "15px",
                right: "20px",
                border: "none",
                background: "none",
                fontSize: "30px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              ×
            </button>

            <h2
              style={{
                textAlign: "center",
                fontWeight: "700",
                marginBottom: "25px",
                color: "var(--primary-color )",
              }}
            >
              CASH IN HAND
            </h2>

            <h5 className="mb-4">Enter the Details</h5>

<div className="row g-3">
  <div className="col-md-6">
    <label className="form-label">
      Adjustment Type <span className="text-danger">*</span>
    </label>
{/* 
    <select
      className="form-select"
      name="adj_type"
      value={formData.adj_type}
      onChange={handleChange}
      required
    >
      <option value="">Select Adjustment Type</option>
      <option value="Add Cash">Add Cash</option>
      <option value="Reduce Cash">Reduce Cash</option>
    </select> */}
    <select
  className="form-select"
  name="adj_type"
  value={formData.adj_type}
  onChange={handleChange}
>
  <option value="">Select Adjustment Type</option>
  <option value="Add">Add Cash</option>
  <option value="Reduce">Reduce Cash</option>
</select>
  </div>


              <div className="col-md-6">
                <label className="form-label">
                  Amount *
                </label>
              <input
  type="number"
  className="form-control"
  name="amount"
  value={formData.amount}
  onChange={handleChange}
  placeholder="Enter Amount"
/>
              </div>

              {/* <div className="col-md-6">
                <label className="form-label">
                  Adjustment Date *
                </label>
               <input
  type="date"
  className="form-control"
  name="adj_on"
  value={formData.adj_on}
  onChange={handleChange}
/> */}

<div className="col-md-6">
  <label className="form-label">
    Adjustment Date & Time *
  </label>

<input
  type="date"
  className="form-control"
  name="adj_on"
  value={formData.adj_on ? formData.adj_on.split(" ")[0] : ""}
  onChange={handleChange}
/>

              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Description
                </label >
          
<textarea
  className="form-control"
  rows="3"
  name="description"
  value={formData.description}
  onChange={handleChange}
  placeholder="Enter Description"
  style={{ resize: "none" }}
/>
              </div>
            </div>

            <div className="text-center mt-4">
              {/* <button className="btn btn-success px-4 py-2">
                Submit Details
              </button> */}
<button
  type="button"
  onClick={handleSubmit}
  className="btn px-4 py-2 text-white fw-semibold"
  style={{
    backgroundColor: "var(--primary-color)",
    border: "1px solid var(--primary-color)",
    borderRadius: "8px",
  }}
>
  Submit Details
</button>
            </div>
          </div>
        </div>
      )}

      
      <div
        className="container-fluid py-3 px-2 px-md-4"
        style={{
          background: "#edf3fb",
          minHeight: "100vh",
        }}
      >
        
        <div
          className="card border-0 shadow-sm mb-4"
          style={{
            borderRadius: "18px",
          }}
        >
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    background: "#f7e3d9",
                    padding: "15px",
                    borderRadius: "12px",
                  }}
                >
                  <FaWallet
                    size={40}
                    color="var(--primary-color)"
                  />
                </div>

                <div>
                  <h3 className="mb-1">
                    Cash In Hand
                  </h3>
{/* 
                  <h2
                    style={{
                      color: "var(--primary-color)",
                      fontWeight: "700",
                      margin: 0,
                    }}
                  >
                    ₹ 0.00
                  </h2> */}
                  <h2
  style={{
    color: "var(--primary-color)",
    fontWeight: "700",
    margin: 0,
  }}
>
  { `₹ ${getTotal("today").toFixed(2)}`}
  {/* ₹ {getTotal("total").toFixed(2)} */}
</h2>
                </div>
              </div>

              <button
                onClick={() =>
                  setShowPartyForm(true)
                }
                className="btn text-white px-4 py-3"
                style={{
                  background: "var(--primary-color)",
                  borderRadius: "30px",
                  fontWeight: "600",
                }}
              >
                + Adjust Cash
              </button>
            </div>
          </div>
        </div>

        <div
          className="card border-0 shadow-sm"
          style={{
            borderRadius: "18px",
          }}
        >
        <div className="card border-0 shadow-sm" style={{ borderRadius: "18px" }}>
  <div className="card-body">

   
    <div className="row align-items-center g-3 mb-4">
  
  <div className="col-12 col-md-4">
    <h4 className="mb-0 fw-bold">
      Transactions
    </h4>
  </div>

  {/* <div className="col-12 col-md-8">
    <div className="d-flex flex-column flex-sm-row justify-content-md-end gap-2">
      
      <input
        type="date"
        className="form-control"
      />

      <input
        type="date"
        className="form-control"
      />

      <button
        className="btn text-white"
        style={{
          background: "var(--primary-color)",
          minWidth: "50px",
        }}
      >
        <FaFilter />
      </button>

    </div>
  </div> */}
  <div className="d-flex flex-wrap justify-content-end gap-2">
<input
  type="date"
  className="form-control"
  value={fromDate}
  onChange={(e) => setFromDate(e.target.value)}
  style={{ width: "160px" }}
/>

<input
  type="date"
  className="form-control"
  value={toDate}
  onChange={(e) => setToDate(e.target.value)}
  style={{ width: "160px" }}
/>

 <button
  className="btn text-white"
  style={{
    background: "var(--primary-color)",
    width: "45px",
  }}
  onClick={handleFilter}
>
  <FaFilter />
</button>
</div>

</div>

    <div className="row g-3 mb-4">
      {summaryData.map((item, index) => (
        <div
          className="col-12 col-sm-6 col-lg-3"
          key={index}
        >
          <div
            style={{
              background: "#f8f9fa",
              padding: "15px",
              borderRadius: "12px",
              height: "100%",
            }}
          >
            <p
              style={{
                marginBottom: "5px",
                color: "#666",
              }}
            >
              {item.title}
            </p>

            <h5
              style={{
                color: "var(--primary-color)",
                fontWeight: "700",
                margin: 0,
              }}
            >
              {item.amount}
            </h5>
          </div>
        </div>
      ))}
    </div>

 
    <div className="table-responsive">
      <table className="table table-hover align-middle">
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Action</th>
          </tr>
        </thead>

       <tbody>
  {cashData.length > 0 ? (
    filteredCashData.map((item, index) => (
      <tr key={item.id || index}>
        {/* <td>{item.adj_type}</td> */}
        <td>
  {item?.c_type
    ? item.c_type === "Balance"
      ? item.adj_type === "Add"
        ? "Payment In"
        : item.adj_type === "Reduce"
        ? "Payment Out"
        : item.c_type
      : item.c_type === "Sale" ||
        item.c_type === "Purchase" ||
        item.c_type === "Expense"
      ? `${item.c_type}${
          item.invoiceNo &&
          Number(item.invoiceNo) !== 0
            ? ` - Inv No: ${item.invoiceNo}`
            : ""
        }`
      : item.c_type
    : `Cash ${item?.adj_type || ""}`}
</td>
        <td>{item.description || "-"}</td>
        <td>
          {new Date(item.adj_on).toLocaleString("en-IN")}
        </td>
        {/* <td
          style={{
            color:
              item.adj_type === "Add Cash"
                ? "green"
                : "red",
            fontWeight: "600",
          }}
        >
          ₹ {Number(item.amount).toFixed(2)}
        </td> */}
        <td
  style={{
    color:
      getCashSign(item) > 0
        ? "green"
        : getCashSign(item) < 0
        ? "red"
        : "#666",

    fontWeight: "600",
  }}
>
  {getCashSign(item) > 0
    ? "+"
    : getCashSign(item) < 0
    ? "-"
    : ""}{" "}
  Rs {getCashAmount(item).toFixed(2)}
</td>
<td>
  <div className="dropdown">
    <button
      className="btn btn-sm border-0"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <BsThreeDotsVertical />
    </button>

    <ul className="dropdown-menu dropdown-menu-end shadow">
      <li>
        {/* <button
          className="dropdown-item"
          // onClick={() => handleViewEdit(item)}
        >
          <FaEye className="me-2 text-primary" />
          View / Edit
        </button> */}
        {/* <button
  className="dropdown-item"
  onClick={() => handleEdit(item)}
>
  <FaEye className="me-2 text-primary" />
  View / Edit
</button> */}
<button
  className="dropdown-item"
  onClick={() => {
    if (item.c_type === "Sale") {
      handleEditSale(item.invoiceNo);
    } else {
      handleEdit(item);
    }
  }}
>
  <FaEye className="me-2 text-primary" />
  View / Edit
</button>
      </li>

      <li>
        <button
          className="dropdown-item"
          onClick={() => handleHistory(item)}
        >
          <FaHistory className="me-2 text-warning" />
          View History
        </button>
      </li>

      <li>
        <button
          className="dropdown-item text-danger"
          onClick={() => handleDelete(item.id)}
        >
          <FaTrash className="me-2" />
          Delete
        </button>
      </li>
    </ul>
  </div>
</td>
      </tr>
    ))
  ) : (
    <tr>
      <td
        colSpan="4"
        className="text-center py-5 text-muted"
      >
        No Transactions Found
      </td>
    </tr>
  )}
</tbody>
      </table>
    </div>

  </div>
</div>
        </div>
      </div>
    </>
  );
};

export default Cash;